export default {
  methods: {
    statusCircle: status => {
      switch (status) {
        case 1:
          return 'circleTrue'
        case 2:
          return 'circleWarning'
        case 3:
          return 'CircleFalse'
        default:
          return 'circleTrue'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/StatusCircle.js